
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Brain, Users, MessageSquare, Settings } from 'lucide-react';

const BoardroomDashboard = () => {
  const agents = [
    { id: 'miles', name: 'Miles', role: 'Business Strategy', status: 'active' },
    { id: 'giselle', name: 'Giselle', role: 'Operations', status: 'active' },
    { id: 'devon', name: 'Devon', role: 'Customer Experience', status: 'active' },
    { id: 'alma', name: 'Alma', role: 'Clinical Support', status: 'active' }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-juv-cream to-juv-sage/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="space-y-6">
          {/* Header */}
          <div>
            <h1 className="text-3xl font-bold font-juv-heading text-juv-deep-chestnut">
              AI Boardroom
            </h1>
            <p className="mt-1 text-juv-deep-chestnut/70">
              Manage your AI agents and automation systems
            </p>
          </div>

          {/* Agent Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {agents.map((agent) => (
              <Card key={agent.id} className="bg-white shadow-luxury border border-juv-rose-clay/30">
                <CardHeader className="text-center">
                  <div className="w-16 h-16 mx-auto bg-juv-terracotta/20 rounded-full flex items-center justify-center mb-4">
                    <Brain className="h-8 w-8 text-juv-terracotta" />
                  </div>
                  <CardTitle className="font-juv-heading text-juv-deep-chestnut">
                    {agent.name}
                  </CardTitle>
                  <p className="text-sm text-juv-deep-chestnut/70">{agent.role}</p>
                </CardHeader>
                <CardContent className="text-center">
                  <div className="space-y-3">
                    <div className="flex items-center justify-center space-x-2">
                      <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                      <span className="text-sm text-green-600">Active</span>
                    </div>
                    <Button size="sm" className="w-full bg-juv-terracotta text-white">
                      Configure
                    </Button>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>

          {/* Quick Actions */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <Card className="bg-white shadow-luxury border border-juv-rose-clay/30">
              <CardContent className="p-6">
                <div className="flex items-center space-x-4">
                  <MessageSquare className="h-8 w-8 text-juv-terracotta" />
                  <div>
                    <h3 className="font-semibold text-juv-deep-chestnut">Script Library</h3>
                    <p className="text-sm text-juv-deep-chestnut/70">Manage AI conversation flows</p>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="bg-white shadow-luxury border border-juv-rose-clay/30">
              <CardContent className="p-6">
                <div className="flex items-center space-x-4">
                  <Users className="h-8 w-8 text-juv-terracotta" />
                  <div>
                    <h3 className="font-semibold text-juv-deep-chestnut">Voice Agent</h3>
                    <p className="text-sm text-juv-deep-chestnut/70">Configure voice interactions</p>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="bg-white shadow-luxury border border-juv-rose-clay/30">
              <CardContent className="p-6">
                <div className="flex items-center space-x-4">
                  <Settings className="h-8 w-8 text-juv-terracotta" />
                  <div>
                    <h3 className="font-semibold text-juv-deep-chestnut">Simulation</h3>
                    <p className="text-sm text-juv-deep-chestnut/70">Test AI scenarios</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BoardroomDashboard;
